import { PPApiService } from '@openeducation/pp-rn-services';
import type { TinyPayloads, ApiError } from '@openeducation/pp-rn-shared-types';
import type { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../../environment/environment.provider';
import { QueryKey } from '../../types';

const LINK_EXPIRED_CODE = 410;

interface UseGetTinyPayloadsInput {
  sfdcToken: string;
}

export const useGetTinyPayloads = ({ sfdcToken }: UseGetTinyPayloadsInput) => {
  const { environment } = useEnvironmentContext();

  const { data, isError, error, isLoading } = useQuery<
    TinyPayloads,
    AxiosError<ApiError>
  >(
    [QueryKey.GetTinyPayloads, sfdcToken],
    () => PPApiService.getTinyPayloads(environment, sfdcToken),
    { enabled: !!sfdcToken, retry: false }
  );

  const apiError: ApiError | undefined = error?.response?.data;
  const isLinkExpired = apiError?.code === LINK_EXPIRED_CODE;

  return {
    data,
    apiError,
    isError,
    isLoading,
    isLinkExpired,
  };
};
